import { EventEmitter, Injectable } from '@angular/core';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LookUpData } from '../jurisdiction/jurisdiction.domain';
import { LocalStorageService } from './local-storage.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetzTranslateService {
  private currentLanguage: string;

  private onTranslationsAdded = new BehaviorSubject<boolean>(false);
  public translationsLoaded$ = this.onTranslationsAdded.asObservable();

  constructor(private translate: TranslateService, private localStorageService: LocalStorageService) {
    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang('de');
    this.currentLanguage = 'de';

    this.translate.onDefaultLangChange.subscribe(data => {
      this.addTranslations(data);
    });
    this.translate.onLangChange.subscribe(data => {
      this.addTranslations(data);
    });
  }

  useLanguage(language: string): void {
    this.currentLanguage = language;
    this.translate.use(language);
  }

  getLangs(): Array<string> {
    return this.translate.getLangs();
  }

  getCurrentLang(): string {
    return this.currentLanguage;
  }

  translateString(key: string, params?: Object): string {
    return this.translate.instant(key, params);
  }

  registerForLanguageChange(): EventEmitter<LangChangeEvent> {
    return this.translate.onLangChange;
  }

  private addTranslations(data): void {
    try {
      let translationData: any;
      if (data.translations.length) {
        translationData = data.translations[0];
        translationData.lookup = (data.translations[1] as LookUpData).lookup;
        this.localStorageService.setItem('lookup_data', translationData.lookup);
      } else {
        translationData = data.translations;
        this.localStorageService.setItem('lookup_data', translationData.lookup);
      }
      this.translate.setTranslation(data.lang, translationData);
    } finally {
      this.onTranslationsAdded.next(true);
    }
  }
}
